const SIDE_LETTER_PENDING_POPUP = {
  side_letter_pending_report: 'buy_up_pending_report',
};

Object.freeze(SIDE_LETTER_PENDING_POPUP);

export { SIDE_LETTER_PENDING_POPUP };
